import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Plus, Edit, Trash2, Eye, Loader2, RefreshCw } from 'lucide-react';
import { toast } from 'sonner';
import { pb } from '../lib/pocketbaseClient';
import { Button } from '../components/ui/button';

const CustomerList = () => {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  const fetchItems = async () => {
    setLoading(true);
    try {
      const records = await pb.collection('users').getFullList({ sort: '-created' });
      setItems(records);
    } catch (error) {
      console.error(error);
      toast.error('Failed to load Customer');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchItems();
  }, []);

  const handleDelete = async (id) => {
    if (!window.confirm('Delete this item?')) return;
    try {
      await pb.collection('users').delete(id);
      toast.success('Deleted successfully');
      fetchItems();
    } catch (error) {
      toast.error('Delete failed');
    }
  };

  if (loading) {
    return <div className="flex justify-center items-center h-64"><Loader2 className="w-8 h-8 animate-spin text-amber-500" /></div>;
  }

  return (
    <div>
      <div className="flex justify-between items-center mb-6">
        <div>
          <h1 className="text-2xl font-bold text-slate-800">Customer Management</h1>
          <p className="text-slate-500 text-sm">Manage your users</p>
        </div>
        <div className="flex gap-2">
          <Button variant="outline" onClick={fetchItems} className="rounded-xl">
            <RefreshCw className="w-4 h-4 mr-2" /> Refresh
          </Button>
          <Button onClick={() => navigate('/file-manager/')} className="bg-amber-500 hover:bg-amber-600 text-white rounded-xl">
            <Plus className="w-4 h-4 mr-2" /> Add New
          </Button>
        </div>
      </div>

      {items.length === 0 ? (
        <div className="text-center py-16 bg-white rounded-2xl border border-slate-200">
          <p className="text-slate-500">No users found. Click "Add New" to create one.</p>
        </div>
      ) : (
        <div className="bg-white rounded-2xl border border-slate-200 overflow-hidden shadow-sm">
          <table className="min-w-full divide-y divide-slate-200">
            <thead className="bg-slate-50">
              <tr>
                <th className="px-6 py-3 text-left text-xs font-medium text-slate-500 uppercase">#</th>
                <th className="px-6 py-3 text-left text-xs font-medium text-slate-500 uppercase">Name / Title</th>
                <th className="px-6 py-3 text-left text-xs font-medium text-slate-500 uppercase">Email</th><th className="px-6 py-3 text-left text-xs font-medium text-slate-500 uppercase">Role</th>
                <th className="px-6 py-3 text-right text-xs font-medium text-slate-500 uppercase">Actions</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-slate-100">
              {items.map((item, idx) => (
                <tr key={item.id} className="hover:bg-slate-50 transition">
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-slate-500">{idx + 1}</td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-slate-800">
                    {item.title || item.name || 'Untitled'}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-slate-500">{item.category || '�'}</td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-slate-500">{item.status || 'draft'}</td>
                  <td className="px-6 py-4 whitespace-nowrap text-right text-sm">
                    <Link to={'/file-manager/'} className="text-indigo-600 hover:text-indigo-800 mr-3">
                      <Edit className="w-4 h-4 inline" />
                    </Link>
                    <button onClick={() => handleDelete(item.id)} className="text-red-500 hover:text-red-700">
                      <Trash2 className="w-4 h-4 inline" />
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default CustomerList;


